export const fontFamily = '"Oriflame sans",SansOri,Helvetica,sans-serif';
export const fontWeightLight = 400;
export const fontWeightRegular = 400;
export const fontWeightMedium = 700;
export const fontWeightBold = 700;
export const htmlFontSize = 10;